import type { PropertyListing } from "@gql";

interface Props {
  propertyListing: Pick<
    PropertyListing,
    "unitNumber" | "addressLine1" | "city" | "province" | "postalCode"
  >;
}

const PropertyListingAddress = ({ propertyListing }: Props) => {
  const getApartmentSuiteNodes = () => {
    if (propertyListing.unitNumber) {
      return (
        <span>
          Unit {propertyListing.unitNumber}
          <br />
        </span>
      );
    }
  };

  return (
    <address className="property-listing-address-component">
      {propertyListing.addressLine1}
      <br />
      {getApartmentSuiteNodes()}
      {propertyListing.city}, {propertyListing.province}
      <br />
      {propertyListing.postalCode}
    </address>
  );
};

export { PropertyListingAddress, type Props };
